import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { ENDPOINTS } from '../../helpers/constants';
import { postToday } from './helpers';

function NoteModal({ lead, onClose, onSaved }) {
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  const save = async event => {
    event.preventDefault();
    setSaving(true);
    const saved = await postToday(ENDPOINTS.CONTACTS_TODAY_NOTE(lead._id), { note });
    setSaving(false);
    if (!saved) return;
    onSaved();
  };

  return (
    <Modal show onHide={onClose} centered>
      <Form onSubmit={save}>
        <Modal.Header closeButton>
          <Modal.Title>Note for {lead.buyer}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="small text-muted">
            This adds a dated line with your name at the top of personal notes.
          </p>
          <Form.Control
            as="textarea"
            rows={4}
            value={note}
            onChange={event => setNote(event.target.value)}
            required
            autoFocus
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-dark" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={!note.trim() || saving}>
            {saving ? 'Saving…' : 'Add note'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default NoteModal;
